import React, { useState } from 'react';
import Container from '@mui/material/Container';
import Grid from '@mui/material/Grid';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import Paper from '@mui/material/Paper';
import Button from '@mui/material/Button';
import TextField from '@mui/material/TextField';
import InputAdornment from '@mui/material/InputAdornment';
import Divider from '@mui/material/Divider';
import EqualizerIcon from '@mui/icons-material/InsertChartOutlined';
import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';
import MenuItem from '@mui/material/MenuItem';
import InputLabel from '@mui/material/InputLabel';

import estimatePenetration from '../lib/penetration'
import { AutoSaveProvider, useAutoSaveState, SaveButton, NameField } from '../lib/useAutoSaveState'
import toFixed from '../lib/toFixed'

const Penetration = () => {
  const [ fps, setFps ] = useAutoSaveState('fps', '')
  const [ pLength, setPLength ] = useAutoSaveState('pLength', '')
  const [ rodMaterial, setRodMaterial ] = useAutoSaveState('rodMaterial', 'tungsten')
  const [ , setPreview ] = useAutoSaveState('preview', null)
  const [ result, setResult ] = useState(null)

  const calculate = () => {
    const result = estimatePenetration(fps, pLength, rodMaterial)
    setResult({ penetration: result })
    setPreview(`${toFixed(result.penetration, 0)} inches`)
    window.gtag('event', 'calculate_penetration_depth')
  }

  return (
    <Container maxWidth="lg" sx={{ mt: 4, mb: 4 }}>
      <Grid container spacing={3} justifyContent="center" >
        <Grid container justifyContent="center" xs={12} sx={{ position: 'relative' }}>
          <Typography variant="h2" component="h1" gutterBottom>
            Armor Penetration Calculator
          </Typography>
          <SaveButton />
        </Grid>
        <NameField />
        <Grid item xs={8}>
          <Paper sx={{ p: 2, display: 'flex', flexDirection: 'column' }}>
            <Grid container spacing={2}>
              <Grid item xs={12}>
                <TextField fullWidth label="Impact Velocity" autoFocus value={fps} onChange={e => setFps(e.target.value)} InputProps={{ endAdornment: <InputAdornment position="end">fps</InputAdornment> }} />
              </Grid>
              <Grid item xs={12}>
                <TextField fullWidth label="Penetrator Length" value={pLength} onChange={e => setPLength(e.target.value)} InputProps={{ endAdornment: <InputAdornment position="end">inches</InputAdornment> }} />
              </Grid>
              <Grid item xs={12}>
                <FormControl fullWidth>
                  <InputLabel>Penetrator Material</InputLabel>
                  <Select
                    value={rodMaterial}
                    label="Penetrator Material"
                    onChange={e => setRodMaterial(e.target.value)}
                  >
                    <MenuItem value="tungsten">Tungsten</MenuItem>
                    <MenuItem value="tungsten93">Tungsten 93</MenuItem>
                    <MenuItem value="depletedUranium">Depleted Uranium</MenuItem>
                    <MenuItem value="forrestalPenetratorSteel">Penetrator Steel</MenuItem>
                  </Select>
                </FormControl>
              </Grid>
              <Grid item xs={12}>
                <FormControl fullWidth>
                  <InputLabel>Target Material</InputLabel>
                  <Select
                    value={"steelRHA"}
                    label="Penetrator Material"
                  >
                    <MenuItem value="steelRHA">RHA Steel</MenuItem>
                  </Select>
                </FormControl>
              </Grid>
            </Grid>
          </Paper>
        </Grid>
        <Grid item xs={8}>
          <Paper sx={{ p: 2, display: 'flex', flexDirection: 'column' }}>
            <Grid container xs={12} justifyContent="center">
              <Button variant="contained" onClick={calculate}>Calculate</Button>
            </Grid>
          </Paper>
        </Grid>
        {result && <Grid item xs={8}>
          <Paper sx={{ p: 2, display: 'flex', flexDirection: 'column' }}>
            <Grid container xs={12} justifyContent="center">
              <Typography variant="h5" gutterBottom>
                <EqualizerIcon /> Results
              </Typography>
            </Grid>
            <Divider style={{ marginBottom: '20px', marginTop: '20px' }} />
            <Box display="flex" justifyContent="space-around" mb={2}>
              <Typography variant="h5">{toFixed(result.penetration, 3)} inches</Typography>
            </Box>
          </Paper>
        </Grid>}
      </Grid>
    </Container>
  )
}

export default function WrappedPenetration () {
  return <AutoSaveProvider>
    <Penetration />
  </AutoSaveProvider>
}
